export default __webpack_public_path__ + "static/media/tytcfdi.c5b7a482.png";